module.exports = __webpack_public_path__ + "media/images/default/pages/about/clinic-2-1fee43d6f74d565189f35eb9732e02bc.jpeg";